import * as React from 'react';
export default class SmsPreview extends React.Component {
    BEM() {
        const classArray = ['sms-preview'];
        if (this.props.alignContent) {
            classArray.push('sms-preview--' + this.props.alignContent);
        }
        if (this.props.className) {
            classArray.push(this.props.className);
        }
        return classArray.join(' ');
    }
    render() {
        return (React.createElement("div", { className: this.BEM() },
            React.createElement("div", { className: "sms-preview__container" },
                React.createElement("div", { className: "sms-preview__container-inner" },
                    React.createElement("div", { className: "sms-preview__text" }, this.props.children)))));
    }
}
